export default __webpack_public_path__ + "static/media/bcp.7ca987fe.png";